import React from 'react'

import { getAspectRatioPadding } from './utils/getAspectRatioPadding'

import { TIconProps } from './iconProps'

const IconTv: React.FC<TIconProps> = (props) => {
  return (
    <div style={props.style} className={`select-none ${props.className || 'w-24'}`} onClick={props.onClick}>
      <div className="relative h-0" style={getAspectRatioPadding(props.aspectRatio)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full left-0 top-0 absolute" viewBox="0 0 48 48">
          <path
            fill="currentColor"
            d="M43 8c.513 0 .935.386.993.883L44 9v23.008c0 .69-.682 1.172-1.332.943-.557-.197-1.225-.383-1.99-.555l-.392-.086-.639-.128-.675-.123-.711-.117-.368-.057-.76-.108-.393-.052-.4-.05-.82-.096-.85-.09-.877-.082-.9-.075-.926-.068-.946-.061-.967-.054-1.236-.055-1.262-.043-1.026-.026-1.04-.016-.491-.005L25 38h10c.552 0 1 .448 1 1s-.448 1-1 1H13c-.552 0-1-.448-1-1s.448-1 1-1h10l-.001-6.996-1.138.014-1.05.023-1.291.04-1.265.053-.99.052-.97.06-.477.033-1.166.09-1.127.102-.87.089-.425.047-.828.1c-.27.034-.536.07-.796.106l-.385.055-.746.116-.36.06-.692.124c-.54.102-1.042.21-1.505.322l-.34.086-.531.146c-.255.074-.493.15-.714.228-.612.216-1.253-.198-1.326-.823L4 32.007V9c0-.513.386-.936.883-.993L5 8h38zm-1 2H5.999L6 30.66l.297-.075c1.623-.404 3.687-.744 6.056-1.004l.552-.058 1.058-.102.542-.047 1.108-.086.565-.04 1.153-.07c.519-.028 1.045-.053 1.579-.075l.805-.03 1.226-.036 1.245-.024.63-.008.633-.004h.994l1.23.01 1.213.022.6.015.595.018 1.175.044.866.04.853.046 1.114.07.547.04 1.07.086 1.04.095c.341.034.676.069 1.006.106l.49.056.95.119c.311.041.615.084.912.128l.44.067.85.14c.803.142 1.544.294 2.213.458l.393.099V10z"
          />
        </svg>
      </div>
    </div>
  )
}
export default IconTv
